import { DDSTypography } from 'den-design-system'
import React from 'react'
import UsageBar from './UsageBar'
import UsageCard from './common/UsageCard'
import palette from '../../global/newPallete'

interface LicenseUsageCardProps {
  usage: number
  totalLicenses: number
  usedLicenses: number
  availableLicenses: number
}

const SFLicenseUsageCard: React.FC<LicenseUsageCardProps> = ({
  usage,
  totalLicenses,
  usedLicenses,
  availableLicenses
}) => {
  return (
    <UsageCard>
      <div className='flex flex-wrap justify-between gap-[16px] '>
        {/* Usage Section */}
        <div className='flex flex-col gap-[8px] w-[200px]'>
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={palette.colors.textDark4}
          >
            Usage
          </DDSTypography.Title>
          <DDSTypography.Title
            type='h4'
            variant='medium'
            color={palette.colors.primary2}
          >
            {isNaN(usage) || !isFinite(usage)
              ? '-'
              : `${Number(usage).toFixed(2)}%`}
          </DDSTypography.Title>
          <UsageBar usage={usage} />
        </div>

        {/* Total Licenses */}
        <div className='flex flex-col gap-[6px] min-w-[150px]'>
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={palette.colors.textDark4}
          >
            Total Licenses
          </DDSTypography.Title>
          <DDSTypography.Title
            type='h4'
            variant='medium'
            color={palette.colors.textDark3}
          >
            {totalLicenses?.toLocaleString('en-US')}
          </DDSTypography.Title>
        </div>

        {/* Used Licenses */}
        <div className='flex flex-col gap-[6px] min-w-[150px]'>
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={palette.colors.textDark4}
          >
            Used Licenses
          </DDSTypography.Title>
          <DDSTypography.Title
            type='h4'
            variant='medium'
            color={palette.colors.textDark3}
          >
            {usedLicenses?.toLocaleString('en-US')}
          </DDSTypography.Title>
        </div>

        {/* Available Licenses */}
        <div className='flex flex-col gap-[6px] min-w-[150px]'>
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={palette.colors.textDark4}
          >
            Available Licenses
          </DDSTypography.Title>
          <DDSTypography.Title
            type='h4'
            variant='medium'
            color={palette.colors.textDark3}
          >
            {availableLicenses?.toLocaleString('en-US')}
          </DDSTypography.Title>
        </div>
      </div>
    </UsageCard>
  )
}

export default SFLicenseUsageCard
